import { render, staticRenderFns } from "./DeanSuperAdminPreSelect.vue?vue&type=template&id=173ffbc7"
import script from "./DeanSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./DeanSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports